/** Простой круговой спиннер в акцентном цвете темы. */
export function Spinner({ size = 24 }: { size?: number }): JSX.Element {
  return (
    <div
      style={{
        width: size,
        height: size,
        border: '2px solid var(--tg-separator)',
        borderTopColor: 'var(--tg-button)',
        borderRadius: '50%',
        animation: 'sword-spin 0.8s linear infinite',
        margin: 'var(--space-lg) auto',
      }}
    >
      <style>{`@keyframes sword-spin { to { transform: rotate(360deg); } }`}</style>
    </div>
  );
}
